import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";

export class PlageHoraire {
    @AutoMap()
    Debut!: Temporal.PlainDateTime;
    @AutoMap()
    Fin!: Temporal.PlainDateTime;

    Color!: string;
    
    public constructor(init?: Partial<PlageHoraire>) {
        Object.assign(this, init);
    }
}